export const fields = {
  customers: 0,
  teams: 1,
  branches: 2,
  offices: 3,
  responsibleGroups: 4,
  withAdvancePayment: 5,
};
